import { queryOptions } from "@tanstack/react-query";
import { fetchCampaignAdGroups } from "@/lib/campaign-api";
import { addReportingDays, type ReportingTimeZone } from "@/lib/reporting-time-zone";
import {
  type ReportingPeriod,
  type ResolvedReportingPeriod,
  resolveReportingPeriod,
} from "@/stores/reporting-period";

export function precedingAdGroupsPeriod(dates: ResolvedReportingPeriod): ReportingPeriod {
  const days =
    Math.round(
      (Date.parse(`${dates.endDate}T00:00:00Z`) - Date.parse(`${dates.startDate}T00:00:00Z`)) /
        86400000,
    ) + 1;
  return {
    type: "custom",
    startDate: addReportingDays(dates.startDate, -days),
    endDate: addReportingDays(dates.startDate, -1),
  };
}
export function campaignAdGroupsQuery(
  campaignId: string,
  range: ReportingPeriod,
  timeZone: ReportingTimeZone,
) {
  const dates = resolveReportingPeriod(range, new Date(), timeZone);
  return queryOptions({
    queryKey: ["campaign", campaignId, "ad-groups", dates.startDate, dates.endDate, timeZone],
    queryFn: ({ signal }) =>
      fetchCampaignAdGroups(campaignId, { type: "custom", ...dates }, timeZone, signal),
    staleTime: 30000,
  });
}
